import { startCase } from 'lodash';
import React from 'react';

import { H5 } from '../Type/Display.h';

const StateCityGuideLinks = (props) => (
  <section>
    <H5>Guides for {startCase(props.city)}</H5>
    <ul>
      <li><a href={`/${props.state.toLowerCase()}/${props.municipalitySlug}/`}>How to File Chapter 7 in {startCase(props.city)}, {props.state}</a></li>
      <li><a href={`/${props.state.toLowerCase()}/${props.municipalitySlug}/attorney-cost-estimate/`}>Attorney Cost Estimates for {startCase(props.city)}, {props.state}</a></li>
      <li><a href={`/${props.state.toLowerCase()}/${props.municipalitySlug}/free-bankruptcy-lawyer/`}>Free Bankruptcy Lawyers for {startCase(props.city)}, {props.state}</a></li>
    </ul>
  </section>
);

export default StateCityGuideLinks;
